// extracted by mini-css-extract-plugin
export default {"disputeLink":"DisputeBadge_disputeLink__8IPz6","externalIcon":"DisputeBadge_externalIcon__SW35X"};